import { initializeSemanticUI } from '../../plugins/SemanticUI';
import { initDatePicker } from '../DatetimeInit';

const initEditRoomRequest = () => {
  initializeSemanticUI();
  initDatePicker();
};

document.addEventListener('roomrequest:initedit', initEditRoomRequest);
